module.exports = __webpack_public_path__ + "static/media/Sweet Brown.db87b9a0.jpg";